var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"id":"platList"}},_vm._l((_vm.iotCarList),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.changePlat(item)}}},[_vm._v("\n    "+_vm._s(item.simNo)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09d0ba3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/iotCardList.vue
// module id = null
// module chunks = 